import Modal from 'components/Modal/Modal'
import React, { useEffect, useState } from 'react'

import classNames from 'classnames';
import { Field, Form } from 'react-final-form'
import { connect } from 'react-redux';

import Button from 'components/Button/Button';
import FormField from 'components/FormField/FormField';
import FormFieldWrapper from 'components/FormFieldWrapper/FormFieldWrapper';

import { actions as fetchUsersDataActions } from 'coupon-common/src/modules/admin/userManager/fetchUsersData';
import { actions as userDetailActions } from 'coupon-common/src/modules/admin/userManager/getUserDetails'
import { actions as updateUserMembershipActions } from 'coupon-common/src/modules/admin/userManager/updateMembership'

const AdminUpdateMembership = ({
  business,
  updateMembershipModal,
  setUpdateMembershipModal,
  styles,
  membership_plans,
  user,
  dispatch,
  updateUserMembershipData,
  updateUserMembershipError
}) => {

  const [apiCall, setApiCall] = useState(false);

  useEffect(() => {

    if (apiCall) {
      if (updateUserMembershipData?.success) {
        alert("User membership information has been updated successfully.")
        dispatch(userDetailActions.getUserDetails(user?.id));
        dispatch(fetchUsersDataActions.getAllUsers());
        setApiCall(false)
        setUpdateMembershipModal(false)
      }
      else if (updateUserMembershipError) {
        alert("There was an error updating the membership information.")
        setApiCall(false)
        setUpdateMembershipModal(false)
      }
    }

  }, [updateUserMembershipData, updateUserMembershipError])


  // console.log("user", user);

  const cancelEdit = (form) => {

    setUpdateMembershipModal(false)
    form.reset();
  }

  return (

    <Form
      initialValues={user?.membership}
      onSubmit={(values, form) => {

        // console.log("values", values);
        const user_type = business ? "business" : "customer";
        dispatch(updateUserMembershipActions.updateMembership(user?.id, user_type, values));
        setApiCall(true)

      }}
      render={({ handleSubmit, form }) => {
        return (
          <Modal
            title={"Update Membership"}
            isOpen={updateMembershipModal}
            onRequestClose={() => cancelEdit(form)}
          >
            <form onSubmit={handleSubmit}>
              {business ? (
                <div>
                  <Field
                    className={classNames(styles.formGroup)}
                    name="plan"
                    label="Membership Plan"
                    component={({ input, meta, label }) => {

                      const currentPlan = membership_plans?.find((plan) => plan.id === meta.initial)

                      return (
                        <FormFieldWrapper
                          invalid={meta.touched && meta.error}
                          label={label}
                          error={meta.error}
                        >
                          <select
                            {...input}
                            style={{ height: "70%" }}
                            onChange={(e) => input.onChange(Number(e.target.value))}
                            className="form-control"
                          >
                            <option value={currentPlan?.id}>{currentPlan?.name}</option>
                            {membership_plans?.map((membership) => (
                              membership.id !== currentPlan?.id && (
                                <option key={membership.id} value={membership.id}>
                                  {membership.name}
                                </option>
                              )
                            ))}
                          </select>
                        </FormFieldWrapper>
                      );
                    }}
                  />

                  <Field
                    className={classNames(styles.formGroup)}
                    name="expiration_date"
                    label="Membership Expiration Date"
                    component={FormField}
                    type="datetime-local"
                  />

                  {/* <Field
              className={classNames(styles.formGroup)}
              name="membership.membership_details.coupon_capacity"
              label="Coupon Capacity"
              component={FormField}
              type="number"
            />
            <Field
              className={classNames(styles.formGroup)}
              name="membership.membership_details.available_coupons"
              label="Available Coupons"
              component={FormField}
              type="number"
            />
            <Field
              className={classNames(styles.formGroup)}
              name="membership.membership_details.sponsorship_capacity"
              label="Sponsorship Capacity"
              component={FormField}
              type="number"
            />
            <Field
              className={classNames(styles.formGroup)}
              name="membership.membership_details.available_sponsorships_slots"
              label="Available Sponsorhsip Slots"
              component={FormField}
              type="number"
            /> */}
                </div>
              ) :
                (
                  <div>
                    <Field
                      className={classNames(styles.formGroup)}
                      name="date_start"
                      label="Membership Start Date"
                      component={FormField}
                      type="datetime-local"
                    />

                    <Field
                      className={classNames(styles.formGroup)}
                      name="is_paid"
                      label="Membership Is Paid"
                      component={FormField}
                      type="checkbox"
                    />

                  </div>

                )}

              <div>
                <Button outline onClick={() => setUpdateMembershipModal(false)}>Cancel</Button>
                <Button type="submit">Save</Button>
              </div>
            </form>
          </Modal>
        )
      }}
    />


  )
}

const mapStateToProps = (state) => {
  return {
    updateUserMembershipData: state.admin.userManager.updateMembership.data,
    updateUserMembershipError: state.admin.userManager.updateMembership.error,
  };
};

export default connect(mapStateToProps)(AdminUpdateMembership);
